export const CALENDLY_URL = "https://calendly.com/tysonworks/30mins";
export const APN_LISTING =
  "https://aws.amazon.com/partners/find/partnerdetails/?id=0010h00001aCbizAAC";
export const IQ_LISTING = "https://iq.aws.amazon.com/c/tysonworks";

export function openCalendly(e) {
  if (e) e.preventDefault();
  if (window.Calendly) {
    window.Calendly.initPopupWidget({ url: CALENDLY_URL });
  } else {
    window.open(CALENDLY_URL, "_blank", "noopener");
  }
}
